import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isGdprAdMarket, areAdsEnabled } from 'owa-mail-ads-shared';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let AdvertisingOption: LazyOption = createLazyOption(
    {
        key: 'advertising_options',
        titleStringKey: 'optionTitle_ads',
        searchTermsStringKey: 'optionTitle_ads',
        hideTitleInFullOptions: true,
        isHidden: () =>
            !(isFeatureEnabled('fwk-gdprAdsPrefs') && isGdprAdMarket() && areAdsEnabled()),
        allowedOptionKeys: ['ManageAdGdprPreference'],
    },
    lazyFullModule,
    m => m.default
);
export default AdvertisingOption;
